import { Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Packages from './Packages';
import OptionalCoverages from '../OptionalCoverages';
import Basic from './Basic';
import BackButton from '../../../Global/BackButton';

class ProductSelector extends Component {
  render() {
    const {
      productBoxes,
      variant,
      advancedCoverage,
      className,
      userData,
      dispatch,
      backButtonConfig,
      hideProductSelectorBackButton
    } = this.props;

    const screenWidth = window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;

    const { showBasicPackage } = userData;

    const selectorClass = classNames(
      'product-selector__inner grid__col grid__col--12', {
        'grid__col--md-4': advancedCoverage || showBasicPackage,
        'grid__col--md-12': !advancedCoverage,
        'grid__col--md-4 grid__col--offset-4': !advancedCoverage &&
          productBoxes.length === 1 && screenWidth > 768,
      }
    );

    const productBoxClass = classNames(
      'product-selector--feature grid ', {
        [`${className}`]: className !== '',
        'alignCenter': showBasicPackage,
      }
    );

    if (!this.state.show) {
      setTimeout(() => { this.setState(() => {
        return { show: true }
      }); }, 10);
    }

    return (
      <div>
        <div className={productBoxClass}>
          {this.props.advancedCoverage &&
          <div className="grid__col grid__col--12 grid__col--md-8 advanced-coverage">
            <OptionalCoverages {...this.props} />
          </div>
          }
          <div className={selectorClass}>
            {variant === 'packages' &&
            <Packages {...this.props} />
            }
            {variant === 'basic' &&
            <Basic {...this.props} />
            }
            {!hideProductSelectorBackButton ? <BackButton
              className={"back-button tealiumSubmit button NavigationContainerBackButton"}
              dispatch={dispatch}
              config={backButtonConfig}
            /> : null}
          </div>
        </div>
      </div>
    );
  }
}

export default ProductSelector;

ProductSelector.defaultProps = {
  actions: [],
  advancedCoverage: false,
  variant: 'packages',
  productBoxes: [],
  className: '',
};

ProductSelector.propTypes = {
  initialValues: PropTypes.object.isRequired,
  productBoxes: PropTypes.array,
  userData: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  advancedCoverage: PropTypes.bool,
  actions: PropTypes.array,
  variant: PropTypes.string,
  productFooterNote: PropTypes.string,
  labelActions: PropTypes.array,
  label: PropTypes.string,
  coverageText: PropTypes.string,
  recommendedText: PropTypes.string,
  toolTip: PropTypes.string,
  buttonTextMobile: PropTypes.string,
  className: PropTypes.string,
  backButtonConfig: PropTypes.object
};